import { Iconify } from '@sohanemon/utils/components';
import { useEffectOnce, useMediaQuery } from '@sohanemon/utils/hooks';
import { m } from '@sohanscript/i18n';
import { GlassSphereScene } from '@sohanscript/ui/three/glass-sphere';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { WindowRenderer } from '#/components/ui/window-renderer.tsx';
import { WINDOW_CONFIGS } from '#/lib/config/windows.tsx';
import { useWindowStore } from '#/lib/store/window-manager.ts';
import { UbuntuDash } from '../-components/ubuntu-dash';

export const Route = createFileRoute('/_main/os')({
	component: RouteComponent,
	ssr: false,
	head: () => ({
		styles: [
			{
				children: `:root { font-size: 14px; }`,
			},
		],
	}),
});

function RouteComponent() {
	const { openWindow, closeAllWindow } = useWindowStore();
	const router = useRouter();
	const lg = useMediaQuery('lg');
	useEffectOnce(closeAllWindow);

	return (
		<>
			{lg ? (
				<GlassSphereScene />
			) : (
				<div className="absolute inset-0 -z-50 flex flex-col items-center justify-center">
					<Iconify
						icon="streamline-logos:arch-linux-logo-solid"
						className="size-50 text-primary/30 lg:size-80"
					/>
					<p className="max-w-[20ch] text-center text-secondary lg:hidden">
						{m.os_thumb_warning()}
					</p>
				</div>
			)}

			<WindowRenderer />
			<UbuntuDash
				showAppsButton
				className="absolute inset-y-0 start-0 my-auto"
				apps={WINDOW_CONFIGS.map((cfg) => ({
					id: cfg.id,
					icon: cfg.icon,
					name: cfg.title,
				}))}
				onAppClick={(id) => {
					const cfg = WINDOW_CONFIGS.find((c) => c.id === id);
					if (cfg && typeof cfg.element === 'string') {
						router.navigate({ to: cfg.element });
						return;
					}
					openWindow(id);
				}}
			/>
		</>
	);
}
